#
# dygraph directive for AngularJS
#
# Author: Chris Jackson
#
# License: MIT
#

Dygraph = require('dygraph')

angular.module("workflow.app")
  .directive 'ngDygraphs', ($$rAF) ->
    return {
      restrict: 'E',
      scope: {
        data: "="
        options: "="
      }
      template: '<div class="ng-dygraphs"><div class="graph"></div></div>',

      link: (scope, element) ->
        mainDiv = element.children()[0]
        chartDiv = $(mainDiv).children()[0]

        graph = undefined
        cancelInit = () ->

        createGraph = () -> new Dygraph(chartDiv, scope.data, scope.options)

        scope.$watchGroup(
          ['data', 'options'],
          () ->
            if graph
              graph = createGraph()
            else
              cancelInit = $$rAF () ->
                graph = createGraph()
        )

        scope.$on '$destroy', () ->
          if graph
            graph.destroy()
          else
            cancelInit()
      }
